import { Modal, Input } from 'antd';
import React from 'react';
import AntDButton from '../Button';

interface IModalProps {
  id?: string;
  show: boolean;
  title: React.ReactNode;
  inputValue: string;
  onInputChange: (value: string) => void;
  onConfirm: () => void;
  onCancel: () => void;
  placeholder: string;
  confirmBtnLabel?: string;
  disabled?: boolean;
  as?: 'input' | 'textarea' | any;
  autoFocus?: boolean;
  disableCnfBtn?: boolean;
  formCtrlStyle?: React.CSSProperties;
  maxLength?: number;
  footerBtnNotNeeded?: boolean;
  bodyStyle?: React.CSSProperties;
}

const FormModal = ({
  id,
  show,
  title,
  inputValue,
  onInputChange,
  onConfirm,
  onCancel,
  placeholder,
  confirmBtnLabel,
  disabled,
  autoFocus,
  as,
  disableCnfBtn,
  formCtrlStyle,
  maxLength,
  footerBtnNotNeeded,
  bodyStyle,
}: IModalProps) => {
  return (
    <Modal
      open={show}
      onCancel={onCancel}
      onOk={onConfirm}
      centered
      title={title}
      maskClosable={false}
      footer={
        disabled || footerBtnNotNeeded ? null : (
          <div style={{ padding: '12px', textAlign: 'right' }}>
            <AntDButton
              key="confirm"
              type="primary"
              disabled={disableCnfBtn}
              onClick={onConfirm}
              statusOnComplete={confirmBtnLabel ?? 'Confirm'}
              htmlType="button"
            />
          </div>
        )
      }
    >
      <div style={{ padding: '1rem' }}>
        {as === 'textarea' ? (
          <Input.TextArea
            id={id}
            value={inputValue}
            onChange={(e) => onInputChange(e.target.value)}
            placeholder={placeholder}
            disabled={disabled}
            autoFocus={autoFocus}
            style={formCtrlStyle}
            maxLength={maxLength}
          />
        ) : (
          <Input
            id={id}
            value={inputValue}
            onChange={(e) => onInputChange(e.target.value)}
            placeholder={placeholder}
            disabled={disabled}
            autoFocus={autoFocus}
            style={formCtrlStyle}
            maxLength={maxLength}
            allowClear
          />
        )}
      </div>
    </Modal>
  );
};

export default FormModal;
